import { useMemo } from 'react'
import { aOrganization, useAtomValue } from '~/atoms'
import { useEmbed } from '~/hooks'
import type { Listing } from '~/models'

function sanitizeURL(url: string): string {
  return url.replace(/\/$/, '')
}

export default function useMapListingLink(listing: Pick<Listing, 'slug'>) {
  const { isEmbed, website } = useEmbed()
  const organization = useAtomValue(aOrganization)

  return useMemo(() => {
    const link = `/listings/${listing.slug}`
    if (isEmbed) {
      if (website) {
        return `${sanitizeURL(website)}${link}`
      } else if (organization?.options.wordpressSiteUrl) {
        return `${sanitizeURL(organization.options.wordpressSiteUrl)}${link}`
      }
    }

    return link
  }, [isEmbed, listing])
}
